import React from "react";
import { Box, Typography, Button, Grid, List, ListItem, ListItemText, Avatar } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";

const stripSpans = (text) => {
  if (!text) return "";
  const div = document.createElement("div");
  div.innerHTML = text;
  return div.textContent || div.innerText || "";
};

function ResultaatScherm({ uuid, questions, onRestart }) {
  const storedData = JSON.parse(localStorage.getItem("quizProgress")) || {};
  const quizData = storedData[uuid] || {};
  const userAnswers = quizData.answers || {};

  const calculateScore = () => {
    return Object.values(userAnswers).filter((answer) => answer.isCorrect).length;
  };

  const finalScore = calculateScore();

  return (
    <Box textAlign="center" p={4}>
      <Typography variant="h4" gutterBottom>
        Resultaten
      </Typography>
      <Typography variant="h5" color="textSecondary" gutterBottom>
        Je score is {finalScore} van de {questions.length} vragen.
      </Typography>

      <Box mt={4}>
        {questions.map((question, index) => {
          const correctAnswers = Object.keys(question.respons).filter(
            (key) => question.respons[key].status
          );
          const userAnswerData = userAnswers[index] || { answers: [] };
          const userAnswer = userAnswerData.answers;

          return (
            <Box key={index} mb={4} p={2} border={1} borderColor="grey.300" borderRadius={4}>
              <Typography variant="h6" gutterBottom>
                Vraag {index + 1}: {stripSpans(question.vraag)}
              </Typography>
              <Typography
                variant="body1"
                color={userAnswerData.isCorrect ? "green" : "red"}
                gutterBottom
              >
                {userAnswerData.isCorrect ? "Juist beantwoord" : "Fout beantwoord"}
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography variant="subtitle1" color="primary">
                    Juiste antwoorden:
                  </Typography>
                  <List>
                    {correctAnswers.map((key) => {
                      const option = question.respons[key];
                      return (
                        <ListItem key={key}>
                          <Avatar style={{ backgroundColor: "green", marginRight: 8 }}>
                            <CheckCircleIcon />
                          </Avatar>
                          <ListItemText
                            primary={stripSpans(option.antwoord)}
                            secondary={stripSpans(option.uitleg) || "Geen uitleg beschikbaar"}
                          />
                        </ListItem>
                      );
                    })}
                  </List>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle1" color="secondary">
                    Jouw antwoorden:
                  </Typography>
                  <List>
                    {userAnswer.map((key) => {
                      const option = question.respons[key];
                      const isCorrectAnswer = option?.status;

                      return (
                        <ListItem key={key}>
                          <Avatar
                            style={{
                              backgroundColor: isCorrectAnswer ? "green" : "red",
                              marginRight: 8,
                            }}
                          >
                            {isCorrectAnswer ? <CheckCircleIcon /> : <ErrorIcon />}
                          </Avatar>
                          <ListItemText
                            primary={stripSpans(option?.antwoord || "Onbekend antwoord")}
                            secondary={stripSpans(option?.uitleg) || "Geen uitleg beschikbaar"}
                          />
                        </ListItem>
                      );
                    })}
                  </List>
                </Grid>
              </Grid>
            </Box>
          );
        })}
      </Box>

      <Button
        variant="contained"
        color="primary"
        onClick={onRestart}
        style={{ marginTop: "20px" }}
      >
        Opnieuw Starten
      </Button>
    </Box>
  );
}

export default ResultaatScherm;
